var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1633 0H7.83673C3.50863 0 0 3.50863 0 7.83673V40.1633C0 44.4914 3.50863 48 7.83673 48H40.1633C44.4914 48 48 44.4914 48 40.1633V7.83673C48 3.50863 44.4914 0 40.1633 0Z",
    fill: "#2A3456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1633 1.95898H7.83673C4.59065 1.95898 1.95918 4.59045 1.95918 7.83654V40.1631C1.95918 43.4091 4.59065 46.0406 7.83673 46.0406H40.1633C43.4093 46.0406 46.0408 43.4091 46.0408 40.1631V7.83654C46.0408 4.59045 43.4093 1.95898 40.1633 1.95898Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.141 24.4897H14.1818V46.0408H16.141V24.4897Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.96 24.4897H32V46.0408H33.96V24.4897Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45454 0H21.2096V29.3878C21.2096 29.9288 20.7711 30.3673 20.2301 30.3673H10.4341C9.89311 30.3673 9.45454 29.9288 9.45454 29.3878V0Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9091 0H38.6655V29.3878C38.6655 29.9288 38.187 30.3673 37.5967 30.3673H27.9778C27.3876 30.3673 26.9091 29.9288 26.9091 29.3878V0Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.83673C0 3.50862 3.50862 0 7.83673 0H40.1633C44.4914 0 48 3.50862 48 7.83673H0Z",
    fill: "#4860AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogoBlue);
export default __webpack_public_path__ + "static/media/dark-logo-blue.caa30093193442b621bc5d930399d072.svg";
export { ForwardRef as ReactComponent };